const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("app/services/env");
const Textarea = require("app/components/fields/Textarea");
const MobileOption = require('app/components/products/configuration-mobile/MobileOption')
const Trans              = require('app/components/trans/Trans')

class TextCardSelector extends Component {

	static get propTypes() {
		return {
			option: PropTypes.any,
			text: PropTypes.any,
			maxChars: PropTypes.number,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			maxChars: 272
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			option: props.option || (this.cards.length > 0 ? this.cards[0].id : null),
			text: props.text || "",
			cardTitle: this.options[0].title,
			optionsOpen: false
		};
	}

	get cards() {
		return env.get("checkout.textCards", []);
	}

	get options() {
		return this.cards.map(card => {
			return {
				value: card.id,
				...card
			};
		});
	}

	hasText(value) {
		let card = this.cards.filter(card => card.id === parseInt(value)).pop();
		return card ? card.has_text : false;
	}

	get counterText() {
      return translate(':charactersLeft bogstaver tilbage.', {charactersLeft: (this.props.maxChars - this.state.text.length)});
	}

	get inputObservationText() {
		if (this.state.text.length > 0) {
			return;
		}

		if (parseInt(this.state.option) === 9) {
			return translate("Et pænt kort til lejligheden er valgt, men der er ikke indtastet nogen korttekst.");
		}

		if (parseInt(this.state.option) === 7) {
			return translate("Printet korttekst er valgt, men der er ikke indtastet nogen korttekst.");
		}
	}

	get textPlaceholder() {
		return translate("Angiv din korttekst her..");
	}

	get value() {
		return {
			type: this.state.option,
			text: this.state.text
		};
	}

	get editIcon () {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
				<g transform="translate(-1160.001 -187)">
					<path d="M618,184.874V189h-7.5v-7.5h4.125l1.5-1.5h-6A1.128,1.128,0,0,0,609,181.124v8.25a1.128,1.128,0,0,0,1.125,1.125h8.25a1.128,1.128,0,0,0,1.125-1.125v-6Z" transform="translate(551.001 8.501)" fill="#444"/>
					<path d="M620.125,178,613,185.124V187h1.875L622,179.874A1.771,1.771,0,0,0,620.125,178Z" transform="translate(550.001 9.001)" fill="#444"/>
				</g>
			</svg>
		)
	}

	get editCardText () {
		return (
			<>
				{this.editIcon}
				<div><Trans>Ret kort</Trans></div>
			</>
		)
	}

	get pickCardText () {
		return (
			<>
				{this.editIcon}
				<div><Trans>Vælg og skriv kort</Trans></div>
			</>
		)
	}

	reset() {
		const option = this.cards.length > 0 ? this.cards[0].id : null;

		this.selectInput.value = option;

		if (this.textInput) {
			this.textInput.value = "";
		}

		this.setState({
			option: option,
			text: ""
		});
	}

	onChange() {
		if (typeof this.props.onChange === "function") {
			return this.props.onChange(this.value);
		}
	}

	_onSelectorChange = (e) => {
		this.setState({option: e.target.value}, () => {
			this.onChange();
		});
	};

	_onTextInput = () => {
		this.setState({text: this.textInput.value}, () => {
			this.onChange();
		});
	};

	renderOptions() {
		return this.options.map(option => {
			return (
				<option key={option.value} value={option.value}>{option.title}</option>
			);
		});
	}

	renderOptionsNew () {
    return this.options.map((option, key) =>
      <MobileOption key={option.value} value={option.value} name='text-selector' text={option.title} defaultChecked={key === 0} onClick={e => this.handleOnClick(e)} />)
  }

	handleOnClick (e) {
    const val = e.target.value
		const chosenArray = this.options.filter(obj => obj.value === parseInt(val))

		this.setState({ 
			option: val,
			cardTitle: chosenArray[0].title,
		}, () => {
			this.onChange();
		});
  };

	renderSelector() {
		return (
			<div className="option-selector">
				<label htmlFor="textCardSelector"><Trans>Valgt kort:</Trans></label>
				<select id="textCardSelector" ref={el => this.selectInput = el} onChange={this._onSelectorChange}
								defaultValue={this.state.option}>{this.renderOptions()}</select>
			</div>
		);
	}

	renderInputObvervation() {
		let text = this.inputObservationText;

		if (text) {
			return (
				<div className="textObservation">{text}</div>
			);
		}
	}

	renderTextInput() {
		if (!this.hasText(this.state.option)) {
			return;
		}

		return (
			<div className="text-input text-input-mobile">
				<div className="product-configurator-title">
					Tekst på kortet
				</div>
				<Textarea ref={el => this.textInput = el} id="textCardInput" onInput={this._onTextInput}
									defaultValue={this.state.text}
									placeholder={this.textPlaceholder}
									maxLength={this.props.maxChars} limitLines={5}/>
				<div className="char-counter">{this.counterText}</div>
				{this.renderInputObvervation()}
			</div>
		);
	}

	renderCardText () {
		if (!this.hasText(this.state.option) || this.state.text === '') {
			return
		}

		return (
			<div className="product-configurator-info__description">
				{this.state.text}
			</div>
		)
	}

	openOptions () {
		this.setState({ optionsOpen: true })
		this.props.editOptions()
	}

	closeOptions () {
		this.setState({ optionsOpen: false })
		this.props.saveOptions()
	}

	render() {
		return (
			<div className="text-card-widget">
				<div className="product-configurator-info product-configurator-info--no-border">
					<div className="product-configurator-info__row">
						<div>
							<span className="product-configurator-info__text"><Trans>Valgt kort: </Trans></span>
							<span className="product-configurator-info__title">{this.state.cardTitle}</span>
						</div>
						<div className="product-configurator-info__title product-configurator-info__title--flex cursor-pointer" onClick={() => this.openOptions()}>
							{this.hasText(this.state.option) ? this.editCardText : this.pickCardText}
						</div>
					</div>
					{this.renderCardText()}
				</div>
				<div className="product-configurator-options" style={this.state.optionsOpen ? { display: 'block' } : null}>
					<div className="product-configurator-title">
                      <Trans>Vælg kort</Trans>
          </div>
					<div className="product-configurator-scrollable">
						<div className="mobile-options">
							{this.renderOptionsNew()}
						</div>
						{this.renderTextInput()}
					</div>
					<button className="btn primary" onClick={() => this.closeOptions()}><Trans>Gem kort</Trans></button>
				</div>
			</div>
		);
	}

}

module.exports = TextCardSelector;
